// extracted by mini-css-extract-plugin
module.exports = {"tabLabel":"Tab_tabLabel__1Al3o colors_tintLink__2Wzqh colors_tint__2PYYF","tabLabelActive":"Tab_tabLabelActive__2pN4b colors_tintBorderBottom__6Cq-D"};